'use client';
import UserAvatar from '@/components/user-avatar';
import { useUserStore } from '@/lib/store/user.store';
import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import PointsRules from './PointsRules';

import Link from 'next/link';
import PointsDetail from './PointsDetail';
import ConversionOrder from './ConversionOrder';
const taskList = [
  {
    icon: '👤',
    title: '注册用户',
    desc: '注册完成后即可得积分',
    points: 500,
    action: '去完成',
    color: 'text-orange-500',
  },
  {
    icon: '🔒',
    title: '完成手机号验证',
    desc: '注册完成后即可得积分',
    points: 100,
    action: '去完成',
    color: 'text-purple-500',

  },
  {
    icon: '🛒',
    title: '第一次加入购物车',
    desc: '首次添加商品到购物车可得积分',
    points: 100,
    action: '去完成',
    color: 'text-blue-500',
  },
  {
    icon: '📐',
    title: '第一次选型',
    desc: '首次选型后可得积分',
    points: 100,
    action: '去完成',
    color: 'text-green-500',
  },
  {
    icon: '📄',
    title: '第一次转报价单',
    desc: '完成报价单转订单可得积分',
    points: 100,
    action: '去转订单',
    color: 'text-yellow-500',
  },
  {
    icon: '🤝',
    title: '推荐新用户',
    desc: '活动期间内邀请新用户注册且下单达标后可得积分',
    points: 100,
    action: '去推荐',
    color: 'text-red-500',
  },
  {
    icon: '📸',
    title: '上传头像',
    desc: '首次上传头像，审核通过后可得积分',
    points: 100,
    action: '去上传',
    color: 'text-pink-500',
  },
  {
    icon: '💳',
    title: '第一次支付',
    desc: '首次完成订单支付可得积分',
    points: 1200,
    action: '去支付',
    color: 'text-indigo-500',
  },
  {
    icon: '🧮',
    title: '第一次计算选型',
    desc: '首次完成计算选型可得积分',
    points: 100,
    action: '去完成',
    color: 'text-teal-500',
  },
  {
    icon: '⚙️',
    title: '完成选型',
    desc: '每日完成选型可获得积分',
    points: 10,
    action: '去选型',
    color: 'text-cyan-500',
  },
  {
    icon: '🏢',
    title: '升级成为认证企业用户',
    desc: '首次上传并提交认证资料，审核通过后可得积分',
    points: 1000,
    action: '去认证',
    color: 'text-gray-500',
  },
  {
    icon: '🔍',
    title: '第一次询价',
    desc: '首次询价后生成报价单可得积分',
    points: 100,
    action: '去询价',
    color: 'text-lime-500',
  },
  {
    icon: '📝',
    title: '第一次查看订单',
    desc: '首次查看订单详情可得积分',
    points: 50,
    action: '去查看',
    color: 'text-amber-500',
  },
  {
    icon: '✅',
    title: '完成订单',
    desc: '订单完成后可得订单实付金额的10%积分',
    points: '实付金额的10%',
    action: '去完成',
    color: 'text-emerald-500',
  },
];
export default function Index() {
  const { userInfo } = useUserStore();
  const [user, setUser] = useState(userInfo);
  useEffect(() => {
    setUser(userInfo);
  }, [userInfo]);


  let [active,setactive] = useState(0)
  console.log(user);
  return (
    <div className="">
      <div className="flex gap-10">
        {/* 用户信息卡片 */}
        <Card className="flex-1">
          <div className="bg-white rounded-lg">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <UserAvatar size={60} />
                <div>
                  <div className="text-lg font-medium">
                    {user?.member?.nickname}您好！
                  </div>
                  <div className="text-gray-600">欢迎来到鼎坚行动！</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button className="bg-orange-500 text-white px-4 py-2 rounded-full">
                  每日签到
                </button>
                <span className="text-gray-400">今日签到+5积分</span>
              </div>
            </div>
          </div>
        </Card>

        {/* 积分信息卡片 */}
        <Card className="flex-1 relative">
          <span className="text-[#999999] absolute top-2 right-2 cursor-pointer" onClick={()=>setactive(1)}>
            如何获取积分？
          </span>

          <div className="bg-white rounded-lg">
            <div className="flex flex-col ">
              <div className="flex  items-center  gap-2">
                <div>
                  <div className="text-gray-600 flex items-center ">
                    <img
                      src="/image/33.png"
                      alt=""
                      className="w-8 h-8   "
                    />{' '}
                    <span>我的积分</span>
                  </div>
                </div>
              </div>
              <div className="flex  justify-between mt-2 px-2 box-border">
                <div className=" text-orange-500">
                  <span className="text-3xl font-bold">0 </span>
                  <span className="text-gray-600 text-sm cursor-pointer" onClick={()=>setactive(2)}>积分明细</span>
                </div>

                <div className="flex gap-2">
                {/* /center/exchange */}
                                     <Link href="/center/exchange">
                                     <button className="bg-orange-500 text-white px-4 py-1.5 rounded">
                    积分兑换
                  </button>
                      </Link>

                  <button className="border border-orange-500 text-orange-500 px-4 py-1.5 rounded" onClick={()=>setactive(3)}>
                    兑换订单
                  </button>
                  <button className="border border-orange-500 text-orange-500 px-4 py-1.5 rounded"  onClick={()=>setactive(0)}>
                    玩赚积分
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* 任务列表 */}
      {
        active==0&&<div className="mt-6">
        <h2 className="text-xl font-medium mb-4">玩赚积分</h2>
        <div className=" grid grid-cols-3 gap-1   max-md:grid-cols-1   max-lg:grid-cols-2">
          {taskList.map((task, index) => (
            <Card key={index}>
              <div
                className="bg-white p-0   flex items-center justify-between"
              >
                <div className="flex-1 flex items-center gap-3">
                  <div
                    className={`w-10 h-10 ${task.color} bg-opacity-10 rounded-lg flex items-center justify-center`}
                  >
                    {task.icon}
                  </div>
                  <div>
                    <div className="font-medium">{task.title}</div>
                    <div className="text-sm text-gray-500">{task.desc}</div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-orange-500">+{task.points}</div>
                  <button className="text-[#999999]">{task.action} &gt;</button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
      }


      {/* 积分规则 */}
      {
       active==1&& <PointsRules />
      }
      

{/* 积分明细 */}
      {
         active==2&&  <PointsDetail />
      }

      {/* 兑换订单 */}
      {
         active==3&&  <ConversionOrder />
      }
    </div>
  );
}
